import React, { useState } from 'react';
import styled from 'styled-components';

import { charts, chartsByTime, views, PERIOD_INCOMPATIBLE_VIEWS } from '../../../constants/event';
import EventChart from '../../../chart/EventChart';
import PeriodChart from '../../../chart/period/PeriodChart';
import EventTableView from '../../table/EventTableView';
import LabelsWrapper from '../../event/LabelsWrapper';
import { toRange } from '../../../converters/eventConverter';
import ChartWrapper from '../../../chart/dashboard/ChartWrapper';

const StyleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const LabelsWrapperContainer = styled.div`
  overflow-y: auto;
`;

const StyleTableViewContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const StyleTableView = styled(EventTableView)`
  width: 100%;
  background-color: white !important;

  .enhanced-table {
    height: 100%;
    width: 100%;
  }
`;

const isAdditionalPeriods = (result) =>
  result.length > 1 &&
  result.some(({ info }) => info.uniqueChar.length > 1 && !info.uniqueChar.includes('Others'));

const EventPreview = (props) => {
  const { unit, setChart, result } = props;
  const [isShowLabels, setIsShowLabels] = useState(false);

  const triggerLabels = () => {
    setIsShowLabels((prevState) => !prevState);
  };

  let { options } = props;
  options = {
    ...options,
    ...toRange(result[0].info),
  };

  const isAdditionalPeriod = isAdditionalPeriods(result);
  return (
    <>
      {charts.includes(options.view) &&
        (!isAdditionalPeriod ? (
          <StyleContainer>
            <ChartWrapper height={isShowLabels ? '65%' : '100%'} unit={unit} setChart={setChart}>
              <EventChart {...props} fromDashboard triggerLabels={triggerLabels} showSort />
            </ChartWrapper>
            <LabelsWrapperContainer>
              {chartsByTime.includes(options.view) && isShowLabels && (
                <LabelsWrapper {...props} options={options} fromDashboard />
              )}
            </LabelsWrapperContainer>
          </StyleContainer>
        ) : (
          <PeriodChart
            {...props}
            options={
              PERIOD_INCOMPATIBLE_VIEWS.includes(options.view)
                ? { ...options, view: views.CHART }
                : options
            }
            fromDashboard
          />
        ))}
      {options.view === views.TABLE && (
        <StyleTableViewContainer>
          <StyleTableView {...props} showTabs />
        </StyleTableViewContainer>
      )}
    </>
  );
};

export default EventPreview;
